// Confronta la versione dell'app in esecuzione (`buildId` del build) con quella vista l'ultima volta, salvata in localStorage e
// in IndexedDB (le due copie si coprono a vicenda: il localStorage può essere svuotato dal browser). `isNew` è vero quando il
// build è cambiato: la PWA ha scaricato una versione nuova e va chiesto di aggiornare. `setNew()` registra quella attuale.
export async function useBuildVersion() {
  const { $localStorage } = useNuxtApp();
  const current = String(useRuntimeConfig().public.buildId ?? "");

  let stored: string | null | undefined = $localStorage.getItem("build_id");
  if (!stored) {
    try {
      const idb = (await getValuesFromIndexedDB(["build_id"])) as { build_id?: string } | null;
      stored = idb?.build_id ?? null;
    } catch {
      stored = null;
    }
  }

  const isNew = !!(stored && stored !== current);

  async function registraVersione(): Promise<void> {
    $localStorage.setItem("build_id", current);
    try {
      await setValuesInIndexedDB({ build_id: current });
    } catch {
      // IndexedDB non disponibile: resta la copia in localStorage
    }
  }

  // Prima esecuzione: nessuna versione vista, si registra quella attuale (senza chiedere nulla)
  if (!stored && current) await registraVersione();

  return { isNew, current, setNew: registraVersione };
}
